
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"fill":"#7C519C","fill-rule":"evenodd","d":"M14.929 6.062c0 .161-.116.313-.233.43l-3.24 3.16.767 4.464c.01.063.01.116.01.179 0 .232-.108.446-.367.446a.725.725 0 01-.357-.107L7.5 12.527l-4.009 2.107a.754.754 0 01-.357.107c-.259 0-.375-.214-.375-.446 0-.063.009-.116.018-.179l.768-4.464-3.25-3.16C.188 6.374.07 6.222.07 6.061c0-.267.277-.375.5-.41L5.054 5 7.063.937c.08-.17.232-.366.437-.366s.357.197.438.366L9.946 5l4.483.652c.214.035.5.143.5.41z"}})])
          )
        }
      }
    